import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { ArrowIcon } from 'app/theme/Icons/ArrowIcon';

interface DatePickerHeaderProps {
  isPreviousMonthActive: boolean;
  goToPreviousMonth: () => void;
  goToNextMonth: () => void;
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

const IconButton = styled.button<{ $isActive?: boolean }>`
  background-color: ${({ theme }) => theme.palette.white};
  border: none;
  cursor: pointer;
  visibility: ${({ $isActive }) => ($isActive ? 'hidden' : 'visible')};

  &:focus {
    outline: none;
  }
`;

const LeftArrowIcon = styled(ArrowIcon)`
  transform: rotate(-90deg);
`;

const RightArrowIcon = styled(ArrowIcon)`
  transform: rotate(90deg);
`;

export const DatePickerHeader = ({
  isPreviousMonthActive,
  goToNextMonth,
  goToPreviousMonth,
  children,
}: PropsWithChildren<DatePickerHeaderProps>): JSX.Element => (
  <Container>
    <IconButton aria-label="previous month" $isActive={isPreviousMonthActive} type="button" onClick={goToPreviousMonth}>
      <LeftArrowIcon />
    </IconButton>
    <strong>{children}</strong>
    <IconButton aria-label="next month" type="button" onClick={goToNextMonth}>
      <RightArrowIcon />
    </IconButton>
  </Container>
);
